import React from "react";
import "./Stats.css";

/**
 * Premium StatsStrip – Enhanced 3-column metrics bar
 * - Maintains white page background
 * - Premium design with enhanced visual hierarchy
 * - Blue accent on + / K+ / % parts
 */
export default function StatsStrip({
  items = [
    { value: "25", accent: "+", label: "Years of Service" },
    { value: "35", suffix: "K", accent: "+", label: "Vehicles Serviced" },
    { value: "100", accent: "%", label: "Customer Satisfaction" },
  ],
}) {
  return (
    <section className="stats-premium" aria-label="Company Statistics">
      <div className="stats-premium__inner">
        {items.map((it, idx) => (
          <div 
            className="stats-premium__item" 
            key={idx} 
            role="group" 
            aria-label={it.label}
          >
            {/* Animated background element */}
            <div className="stats-item__glow" aria-hidden="true" />
            
            {/* Value with enhanced styling */}
            <div className="stats-premium__value" aria-hidden="true">
              <span className="stats-value__main">{it.value}</span>
              {it.suffix && <span className="stats-value__suffix">{it.suffix}</span>}
              <span className="stats-value__accent">{it.accent}</span>
            </div>
            
            {/* Enhanced label */}
            <div className="stats-premium__label">
              {it.label}
            </div>
            
            {/* Premium divider */}
            {idx < items.length - 1 && (
              <span className="stats-premium__divider" aria-hidden="true" />
            )}
          </div>
        ))}
      </div>
    </section>
  );
}